/**
 * このゲームの唯一の識別子。
 *
 * **Phaser を引かない軽いモジュールにしておくこと**。
 * `src/games/registry.ts` から**静的に** import されるので、ここが重いと
 * 初期バンドルにゲーム本体が載ってしまう（遅延読込の意味が消える）。
 *
 * この文字列は5か所で同じでなければならない:
 *   D1 の `game_key` / `src/games/slide/` / `src/locales/<lang>/slide.json` /
 *   `public/assets/slide/` / localStorage の `slide.*`
 *
 * 💡 名前について: 「スライドパズル / Sliding Puzzle」は**記述的な一般名**で、
 *    15パズルは1880年代の公有物。他社の登録商標を避ける必要があるのは
 *    ピクロス / 数独 / オセロ / 倉庫番 の系統（docs/GAMES-ROADMAP.md の命名規則）。
 *
 * 🔴 このキーは**予告カードとして本番に出ている**（`UPCOMING` の `slide`）。
 *    カタログの `portal.game.slide.name` / `.desc` は既に日英とも入っているので、
 *    `GAMES` へ移すときに**キーを変えない**こと（変えると予告と別物になる）。
 */
export const GAME_KEY = 'slide';
